// debug开关
let DEBUG = true;
/**
 * 设置log输出是否开启
 * @param enabled 是否开启log输出。默认开启log输出。
 */
export function setDebug(enabled: boolean) {
    DEBUG = enabled;
}

interface ReportFunc {
    (params?: object): void;
}
let reportFunc: ReportFunc = function () { console.log('★report=========>', arguments[0]) }; // 上报日志函数
/**
 * 设置日志上报函数
 * @param report 进行上报的函数
 */
export function setLogReport(report: ReportFunc) {
    if( typeof(report) === 'function' ){
        reportFunc = report;
    }
}
/** @internal 数据上报方法 */
export function _report(data?: object) {
    reportFunc(data);
}

export function _error(arg1: Object, ...rest: Object[]) {
    if (!DEBUG) return;

    const date = new Date();
    let prefix = '%s %s %s\n';
    if (typeof arg1 === 'string') {
        prefix = prefix + arg1;
        console.error(
            prefix,
            date.toLocaleDateString(),
            date.toLocaleTimeString(),
            '[WebIM-SDK][error]:',
            ...rest
        );
    } else {
        console.error(
            prefix,
            date.toLocaleDateString(),
            date.toLocaleTimeString(),
            '[WebIM-SDK][error]:',
            arg1,
            ...rest
        );
    }
}

export function _log(arg1: Object, ...rest: Object[]) {
    if (!DEBUG) return;

    const date = new Date();
    let prefix = '%s %s %s\n';
    if (typeof arg1 === 'string') {
        prefix = prefix + arg1;
        console.log(
            prefix,
            date.toLocaleDateString(),
            date.toLocaleTimeString(),
            '[WebIM-SDK][log]:',
            ...rest
        );
    } else {
        console.log(
            prefix,
            date.toLocaleDateString(),
            date.toLocaleTimeString(),
            '[WebIM-SDK][log]:',
            arg1,
            ...rest
        );
    }
}
